import { Link } from '@/ui'

export const ImageOffset = ({
  imageLink,
  linkText,
  backgroundSize = '100%',
  ...rest
}: {
  imageLink: string
  linkText: string
  // ie '-373px -157px' where x offset is first then y offset is second.  If none is sent the image with stick to the top left
  backgroundPosition?: string
  // ie '200%' how zoomed in the image is.  Defaults to 100% which is not zoomed in
  backgroundSize?: string
  height: number
  width: number
}) => (
  <>
    <div className="flex justify-center">
      <div
        style={{
          backgroundImage: `url(${imageLink})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize,
          ...rest,
        }}
      />
    </div>
    <div className="flex justify-center mt-2">
      <Link newPage href={imageLink} variant="secondary">
        {linkText}
      </Link>
    </div>
  </>
)
